import $axios from '@/axios/config.js'
import { url } from '../../axios/api_urls/ingredientSelection'
const api = require('../../axios/request')
import { getDictionary } from '../../axios/api/dictionary'
const UPDATE_STATE = 'UPDATE_STATE'
const UPDATE_OPTIONS = 'UPDATE_OPTIONS'
const UPDATE_RELEASE_COUNTRY = 'UPDATE_RELEASE_COUNTRY'
const UPDATE_RELATED_FORMULATION = 'UPDATE_RELATED_FORMULATION'
const state = {
  options: {
    subCategory: [],
    category: []
  },
  INCIFilter: {
    functionId: '',
    functionClaimId: '',
    categoryId: '',
    subCategoryId: '',
    releaseCountryId: '',
    orderBy: undefined
    // area: '',
  },
  INCIPage: {
    total: 0,
    current: 1,
    size: 10,
    realTotal: 0
  },
  tradeFilter: {
    functionId: '',
    segmentId: '',
    deliveryFormId: '',
    keyWord: '',
  },
  tradePage: {
    total: 0,
    current: 1,
    size: 10
  },
  releaseCountry: [],
  relatedFormulation: []
}
const getters = {
  options: state => state.options,
  INCIPage: state => state.INCIPage,
  INCIFilter: state => state.INCIFilter,
  tradePage: state => state.tradePage,
  tradeFilter: state => state.tradeFilter,
  releaseCountry: state => state.releaseCountry.map(v => {
    return {
      ...v,
      name: v.countryName
    }
  }),
  relatedFormulation: state => state.relatedFormulation
}
const mutations = {
  [UPDATE_STATE] (context, payload) {
    context[payload.key] = payload.value
  },
  [UPDATE_OPTIONS] (context, payload) {
    context.options[payload.key] = payload.value
  },
  [UPDATE_RELEASE_COUNTRY] (context, payload) {
    context.releaseCountry = payload
  },
  [UPDATE_RELATED_FORMULATION] (context, payload) {
    context.relatedFormulation = payload
  }
}
const actions = {
  getSubFuncList ({ commit }, payload) {
    return api._post(url.funcList, { pid: payload })
  },
  getBrand ({ commit }, payload) {
    return api._post(url.brand, { groupId: payload })
  },
  getGroup ({ commit }, payload) {
    return api._post(url.group, { keyword: payload })
  },
  getInit ({ commit }) {
    api._post(url.funcList, { type: 1 }).then(res => { commit(UPDATE_OPTIONS, { key: 'funcList', value: res.data || [] }) })
    api._post(url.funcTradeList, { targetList: [351, 352] }).then(res => { commit(UPDATE_OPTIONS, { key: 'funcTradeList', value: res.data || [] }) })
    getDictionary(135).then(res => { commit(UPDATE_OPTIONS, { key: 'country', value: res.data || [] }) })
    api._post(url.segmentList, { marketSegment: 1, pid: 0 }).then(res => { commit(UPDATE_OPTIONS, { key: 'segment', value: res.data || [] }) })
    api._post(url.ecoStatusesList).then(res => { commit(UPDATE_OPTIONS, { key: 'eco', value: res.data || [] }) })
    api._post(url.delivery, { pid1: 89, pid2: 0 }).then(res => { commit(UPDATE_OPTIONS, { key: 'delivery', value: res.data || [] }) })
  },
  // inci
  getINCIList ({ commit }, payload) {
    return api._post(url.INCIlist, {
      ...payload,
      releaseCountryIds: payload.releaseCountryIds ? payload.releaseCountryIds.join(',') : undefined
    })
  },
  getINCIDetail ({ commit }, payload) {
    return api._post(url.INCIDetail, { compositionId: payload })
  },
  getINCIAppAnalysis ({ commit }, payload) {
    return api._post(url.INCIAppAnalysis, payload)
  },
  getINCItop10 ({ commit }, payload) {
    return api._post(url.INCItop10, payload)
  },
  getINCIMoreFormulation ({ commit }, payload) {
    return api._post(url.INCIMoreFormulation, payload)
  },
  getINCIMoreINCI ({ commit }, payload) {
    return api._post(url.INCIMoreINCI, payload)
  },

  // trade
  getTradeList ({ commit }, payload) {
    return api._post(url.tradeList, payload)
  },
  getTradeDetail ({ commit }, payload) {
    return api._post(url.tradeDetail, payload)
  },

  //download
  download (content, payload) {
    return $axios({
      url: url.download,
      method: 'get',
      params: { fileId: payload },
      responseType: 'arraybuffer'
    })
  },
  async getGoodsSubCategory ({ commit }, payload) {
    try {
      const {data: res} = await api._post(url.getGoodsSubCategory, payload)
      commit(UPDATE_OPTIONS, { key: 'subCategory', value: res || []})
      return res || []
    } catch (e) {
      commit(UPDATE_OPTIONS, { key: 'subCategory', value: []})
      return []
    }
  },
  async getReleaseCountryApi({ commit }, payload) {
    try {
      const {data: res} = await api._post(url.getReleaseCountry, payload)
      commit(UPDATE_RELEASE_COUNTRY, res || [])
    } catch (e) {}
  },
  async getRelatedFormulationApi({ commit }, payload) {
    try {
      const {data: res} = await api._post(url.getRelatedFormulation, payload)
      commit(UPDATE_RELATED_FORMULATION, res || [])
    } catch (e) {}
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/ingredientSelection.js